// React Imports
import { ReactElement } from "react";

// Local Imports
import CollapseComponent from "../../../../components/collapse.component";

interface ProfessionalInformationProps {
  [key: string]: any;
}

const ProfessionalInformation: React.FC<ProfessionalInformationProps> = ({
  accountKycDetails,
}: ProfessionalInformationProps): ReactElement => {
  return (
    <section className="flex flex-col w-full h-full">
      <div className="flex flex-col p-[10px]">
        <CollapseComponent
          header={
            <div className="flex gap-3 items-center">
              <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
              <h3 className=" text-xl font-semibold">Professional details</h3>
            </div>
          }
        >
          <div className="flex gap-5 flex-wrap mb-5">
            <div className="w-[32%] flex flex-col">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Current job
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.employmentStatus
                  ?.description || "-"}
              </span>
            </div>
            {(accountKycDetails?.accountInfo[0]?.employmentStatus
              ?.description === "Other" ||
              accountKycDetails?.accountInfo[0]?.employmentStatus
                ?.description === "Self-Employed") && (
                <div className="w-[32%] flex flex-col">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Nature of work
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.workNature || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.employmentStatus
              ?.description === "Employee" && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Employer Name
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.employerName || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.employmentStatus
              ?.description === "Retired" && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Previous Employer Name
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.employerName || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.employmentStatus
              ?.description === "Employee" && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Occupation & Title
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.occupationTitle || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.employmentStatus
              ?.description === "Retired" && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Previous Occupation & Title
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.occupationTitle || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.employmentStatus
              ?.description === "Retired" && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Previous Work Address
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.retirementAddress || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.employmentStatus?.description?.trim() ===
              "Self Employed" && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Work nature
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.workNature || "-"}
                  </span>
                </div>
              )}
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Classification
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.qualifiedProfessionalClient
                  ? "Qualified professional client"
                  : "Retail client"}
              </span>
            </div>
            {accountKycDetails?.accountInfo[0]?.qualifiedProfessionalClient && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  I have dealings with securities of not less than KWD 250,000
                  every quarter during the previous two years
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.isDealingInSecurities
                    ? "Yes"
                    : "No"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.qualifiedProfessionalClient && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  I have funds and assets with Kamco Investment Company, Other
                  licensed companies, or both not less than KWD 100,000
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.isFundsInKamco
                    ? "Yes"
                    : "No"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.qualifiedProfessionalClient && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  I have worked in the financial sector for at least one year in
                  a professional position
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.isWorkInFinancial
                    ? "Yes"
                    : "No"}
                </span>
              </div>
            )}
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Education Level
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.educationLevel
                  ?.description || "-"}
              </span>
            </div>
            {accountKycDetails?.accountInfo[0]?.educationLevelId == -1 && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Other education level
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.educationLevelOther ||
                    "-"}
                </span>
              </div>
            )}
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Are you a politically exposed person?
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.pep1 ||
                  accountKycDetails?.accountInfo[0]?.pep2 ||
                  accountKycDetails?.accountInfo[0]?.pep3 ||
                  accountKycDetails?.accountInfo[0]?.pep4 ||
                  accountKycDetails?.accountInfo[0]?.pep5 ||
                  accountKycDetails?.accountInfo[0]?.pep6 ||
                  accountKycDetails?.accountInfo[0]?.pep7
                  ? "Yes"
                  : "No"}
              </span>
            </div>
            {(accountKycDetails?.accountInfo[0]?.pep1 ||
              accountKycDetails?.accountInfo[0]?.pep2 ||
              accountKycDetails?.accountInfo[0]?.pep3 ||
              accountKycDetails?.accountInfo[0]?.pep4 ||
              accountKycDetails?.accountInfo[0]?.pep5 ||
              accountKycDetails?.accountInfo[0]?.pep6 ||
              accountKycDetails?.accountInfo[0]?.pep7) && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Related categories
                  </p>
                  <ol className=" list-disc list-inside">
                    {accountKycDetails?.accountInfo[0]?.pep1 ? (
                      <li className=" text-base font-semibold text-lightGray-200">
                        Judge or member of an official legal council
                      </li>
                    ) : null}
                    {accountKycDetails?.accountInfo[0]?.pep2 ? (
                      <li className=" text-base font-semibold text-lightGray-200">
                        Close family member (first and second degree) or associate of the persons above mentioned
                      </li>
                    ) : null}
                    {accountKycDetails?.accountInfo[0]?.pep3 ? (
                      <li className=" text-base font-semibold text-lightGray-200">
                        Senior executive for a state owned corporation / organization
                      </li>
                    ) : null}
                    {accountKycDetails?.accountInfo[0]?.pep4 ? (
                      <li className=" text-base font-semibold text-lightGray-200">
                        Senior military official
                      </li>
                    ) : null}
                    {accountKycDetails?.accountInfo[0]?.pep5 ? (
                      <li className=" text-base font-semibold text-lightGray-200">
                        Head of state / government / member of ruling family
                      </li>
                    ) : null}
                    {accountKycDetails?.accountInfo[0]?.pep6 ? (
                      <li className=" text-base font-semibold text-lightGray-200">
                        Senior politician / minister / member of parliament
                      </li>
                    ) : null}
                    {accountKycDetails?.accountInfo[0]?.pep7 ? (
                      <li className=" text-base font-semibold text-lightGray-200">
                        Close family member (first and second degree) or associate
                        of the persons above mentioned
                      </li>
                    ) : null}
                    {accountKycDetails?.accountInfo[0]?.pep8 ? (
                      <li className=" text-base font-semibold text-lightGray-200">
                        Senior government official
                      </li>
                    ) : null}
                  </ol>
                </div>
              )}
            {(accountKycDetails?.accountInfo[0]?.pep1 ||
              accountKycDetails?.accountInfo[0]?.pep2 ||
              accountKycDetails?.accountInfo[0]?.pep3 ||
              accountKycDetails?.accountInfo[0]?.pep4 ||
              accountKycDetails?.accountInfo[0]?.pep5 ||
              accountKycDetails?.accountInfo[0]?.pep6 ||
              accountKycDetails?.accountInfo[0]?.pep7) && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Details
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.pepDetails || "-"}
                  </span>
                </div>
              )}
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                member of the board of directors or member of the executive
                management or an insider of a listed company
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.isBoardMember
                  ? "Yes"
                  : "No"}
              </span>
            </div>
            {accountKycDetails?.accountInfo[0]?.isBoardMember ? (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Board member details
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.boardMemberDetails || "-"}
                </span>
              </div>
            ) : null}
          </div>
        </CollapseComponent>
      </div>
    </section>
  );
};

export default ProfessionalInformation;
